import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
} from '@angular/common/http';
import { tap, catchError, finalize } from 'rxjs/operators';
import { throwError } from 'rxjs';
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor() {}
  intercept(request: HttpRequest<unknown>, next: HttpHandler) {
    return next.handle(request).pipe(
      tap(
        (_req) => {},
        (_err) => {},
      ),
      catchError((err) => throwError(err)),
      finalize(() => {}),
    );
  }
}
